/**
 * The visitor's cookie choice, for code that may only store something with
 * consent (the affiliate referral cookie, plugins/affiliate.client.ts).
 *
 * Consent is the banner's "Accept" (or switching tracking on at /cookies)
 * without a later opt-out. Changes are announced with a window event, so
 * listeners can act the moment the choice is made.
 */
export const COOKIE_CONSENT_EVENT = 'imr:cookie-consent'

export function hasCookieConsent(): boolean {
  try {
    return localStorage.getItem('cookie_banner_accepted') === 'true'
      && localStorage.getItem('analytics_tracking_enabled') !== 'false'
  } catch {
    return false
  }
}

export function announceCookieConsent(granted: boolean): void {
  try {
    window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: { granted } }))
  } catch {
    // Old browsers without CustomEvent: listeners read hasCookieConsent() later.
  }
}
